<template>
  <div class="pt-vod mb_controller w-100 max-width-player">
    <div
      class="container-fluid my-2 my-md-4 mx-auto px-2 px-md-3"
      style="max-width: 1440px;"
    >
      <div class="row">
        <div class="col-12 px-0">
          <div class="epg-wrapper px-3">
            <iframe
              class="epg-iframe-box"
              :src="
                `https://rtm-epg.glue.live/epgs?mode=dark&menu=1&hCol=2d323d&pCol=dae12f&type=radio&link=RTMKlik`
              "
              frameborder="0"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  data: function() {
    return {};
  },
  components: {},
  created: function() {
    // this.$store.dispatch("fetchRTMTVList", { self: this });
  },
  methods: {},
  mounted() {
    // this.deviceCheck();
  },
  beforeMount() {
    // this.init();
  },
};
</script>

<style scoped>
.mb_controller {
  margin-bottom: 40px;
}
.pt-vod {
  padding: 90px 0 0;
  min-height: 80vh;
}
.min-height-for-section {
  /* min-height: 100vh; */
  padding-bottom: 80px;
}
.cursor-pointer {
  cursor: pointer;
}
.set-overflow {
  overflow-y: hidden;
}
.pt-livetv {
  padding-top: 90px;
}

.epg-wrapper {
  width: 100%;
  height: 1000px;
}
.epg-iframe-box {
  width: 100%;
  height: 100%;
}
@media only screen and (max-width: 992px) {
}

@media only screen and (max-width: 768px) {
}

@media screen and (max-width: 600px) {
}
@media only screen and (max-width: 480px) {
}
</style>
